module.exports = __webpack_public_path__ + "media/images/bg_service_pr_pc-54d85fce04536498686381dcb0c4cad6.jpg";